// WhatsappContact.js

const WhatsappContact = () => {
    return (
        <div className="whatsapp">
            <a href="https://api.whatsapp.com/send?phone=919650165000" target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp" aria-hidden="true"></i><span className="sr-only">Chat with Ajit Furniture House on WhatsApp</span></a>

            <div className="whatsapp-notification">1</div>
        </div>
    )
}

export default WhatsappContact;